import * as Yup from "yup";

export const globalDiscountValidation = Yup.object().shape({
  percent: Yup.string().required("وارد کردن درصد الزامی است"),
});
